import { render } from "./DijiaNumberPoolSource.vue?vue&type=template&id=27e28a15&scoped=true"
import script from "./DijiaNumberPoolSource.vue?vue&type=script&lang=js"
export * from "./DijiaNumberPoolSource.vue?vue&type=script&lang=js"

import "./DijiaNumberPoolSource.vue?vue&type=style&index=0&id=27e28a15&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27e28a15"

export default script